import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { OrganizationsService } from '../../services/organizations.service'
import { Subscription } from 'rxjs'
import { PendingRejectedActions } from 'src/app/modules/organization/models/pending-rejected-actions.model'
import { TranslateService } from '@ngx-translate/core'
import { BranchTypes } from 'src/app/shared/enums/branch-types.enum'
import { ActivatedRoute, Router } from '@angular/router'
import { OrganizationStatus } from '../../models/organizations.enum'
import { ToastrService } from 'ngx-toastr'
import { SharedService } from 'src/app/shared/services/shared.service'

@Component({
	selector: 'app-oranization-pending-actions',
	templateUrl: './oranization-pending-actions.component.html',
	styleUrls: ['./oranization-pending-actions.component.scss'],
})
export class OranizationPendingActionsComponent implements OnInit, OnDestroy {
	subscription = new Subscription()
	Data!: PendingRejectedActions
	currentLang: string = ''
	BranchTypes = BranchTypes
	id!: string | null
	status = OrganizationStatus
	// breadCrumbRout: any
	constructor(
		private dialog: MatDialog,
		private OrganizationsService: OrganizationsService,
		public translate: TranslateService,
		private route: ActivatedRoute,
		private router: Router,
		private toaster: ToastrService,
		private SharedService: SharedService
	) {
		this.Data = this.route.snapshot.data['data']
		this.SharedService.handleBreadCrumb('pending-request', false, {
			name: '',
			id: '',
			url: '',
			queryParams: null,
		})
	}

	ngOnInit(): void {}
	openDialog(ACTION: string) {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '550px',
				// height: '340px',
				data: {
					notflex: true,
					image: `assets/images/${
						ACTION == 'REJECT' ? 'block.svg' : 'correct.svg'
					}`,
					message: `${
						ACTION == 'REJECT'
							? this.translate.instant(
									'CONFIRMATION_MESSAGE.ORG_PENDING_REJECTION',
									{
										name: this.Data.businessName,
									}
							  )
							: this.translate.instant(
									'CONFIRMATION_MESSAGE.ORG_PENDING_ACCEPTANCE',
									{
										name: this.Data.businessName,
									}
							  )
					} `,
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: `ACTIONS.${ACTION == 'REJECT' ? 'REJECT' : 'ACCEPT'}`,
					confirmBtnStyle: ` ${
						ACTION == 'REJECT'
							? 'text-off-white bg-red-error'
							: 'text-off-white bg-gradient'
					}`,
					cancelBtnStyle: `border-[1px] border-secondry-color-Gray text-dark-grey border-solid`,
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						ACTION == 'ACCEPT'
							? this.acceptOrganizationProfile()
							: this.rejectOrganizationProfile()
					}
				},
			})
	}

	acceptOrganizationProfile() {
		this.subscription.add(
			this.OrganizationsService.acceptOrganization(this.Data.id).subscribe(
				() => {
					this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))

					this.router.navigate(['/'], {
						queryParams: { status: 1 },
					})
				}
			)
		)
	}

	rejectOrganizationProfile() {
		this.subscription.add(
			this.OrganizationsService.rejectOrganization(this.Data.id).subscribe(
				() => {
					this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))

					this.router.navigate(['/'], {
						queryParams: { status: 1 },
					})
				}
			)
		)
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
